import { render, staticRenderFns } from "./jubao.vue?vue&type=template&id=1cac1612&scoped=true&"
import script from "./jubao.vue?vue&type=script&lang=js&"
export * from "./jubao.vue?vue&type=script&lang=js&"
import style0 from "./jubao.vue?vue&type=style&index=0&id=1cac1612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cac1612",
  null
  
)

export default component.exports